module.exports = __webpack_public_path__ + "img/1388aa1.svg";